import { ApplicationInsights } from '@microsoft/applicationinsights-web'

const instrumentationKey = document.body.getAttribute('data-instrumentation-key') || '';
export const appInsights = new ApplicationInsights({ config: { instrumentationKey } });